import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg14X14VisibleOffOutline = function Svg14X14VisibleOffOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 14 14"
  }, props, {
    width: "14",
    height: "14"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#14x14_visible_off_outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.293 3.121a1 1 0 0 1 1.414-1.414l9.586 9.586a1 1 0 0 1-1.414 1.414l-1.203-1.203A7.5 7.5 0 0 1 7 12C4.22 12 1.455 10.448.088 7.41a1 1 0 0 1 0-.82 8 8 0 0 1 1.965-2.71zM3.47 5.3l1.536 1.536a2 2 0 0 0 2.158 2.158l.902.902A5.5 5.5 0 0 1 7 10c-1.895 0-3.804-.982-4.886-3A5.9 5.9 0 0 1 3.47 5.299Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.216 2.216A7.5 7.5 0 0 1 7 2c2.78 0 5.545 1.552 6.912 4.59a1 1 0 0 1 0 .82 8.1 8.1 0 0 1-1.377 2.125l-1.417-1.417c.286-.329.545-.701.768-1.118C10.805 4.982 8.896 4 7 4z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "14x14_visible_off_outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  })))));
};
export default Svg14X14VisibleOffOutline;